import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from "../Common/Loading";
import masterbg from "./Image/MasterBKG.png"

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

interface RolePermissions {
  [key: string]: boolean;
}

interface Office {
  Login: string;
  FName: string;
  Password: string;
}

const SupportDashboard: React.FC = () => {

  const [roles, setRoles] = useState<RolePermissions>({});
  const [offices, setOffices] = useState<Office[]>([]);
  const [selectedOffice, setSelectedOffice] = useState('');
  const [jrValue, setJrValue] = useState('1');
  const [srValue, setSrValue] = useState('2');
  const [category, setCategory] = useState('');
  const [supportSchoolCode, setSupportSchoolCode] = useState('');
  const [supportFamilyCode, setSupportFamilyCode] = useState('');
  const [supportLogin, setSupportLogin] = useState('');
  const [userCategory, setUserCategory] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const navigate = useNavigate();

  document.body.style.backgroundColor = "azure";

  useEffect(() => {
    // Disable context menu
    const disableContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };
    document.addEventListener('contextmenu', disableContextMenu);

    loadDashboardData();

    return () => {
      document.removeEventListener('contextmenu', disableContextMenu);
    };
  }, []);

  const loadDashboardData = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const login = sessionStorage.getItem("login");
      console.log("login", login)
      const school_code = sessionStorage.getItem("school_code");
      console.log("school code", school_code)
      const family_code = sessionStorage.getItem("family_code");
      console.log("family_code", family_code)
      const category = sessionStorage.getItem("category");
      console.log("category", category)

      // if (!login || !school_code || !family_code) {
      //   window.location.href = "/login";
      //   return;
      // }

      const response = await fetch(`${API_BASE_URL}api/support_dashboard/data/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          login: sessionStorage.getItem("login") || sessionStorage.getItem("Login"),
          school_code: sessionStorage.getItem("school_code") || sessionStorage.getItem("SelectedSchoolCode"),
          family_code: sessionStorage.getItem("family_code") || sessionStorage.getItem("S"),
          // category: category,
        })
      });

      // if (!response.ok) {
      //   if (response.status === 401) {
      //     sessionStorage.clear();
      //     window.location.href = "/login";
      //     return;
      //   }
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }

      const data = await response.json();

      if (data.success) {
        setRoles(data.roles || {});
        setOffices(data.offices || []);
        setSupportSchoolCode(data.support_school_code || "");
        setSupportFamilyCode(data.support_family_code || "");
        setSupportLogin(data.support_login || "");
        setUserCategory(data.category || "");
      } else {
        setError("Failed to load dashboard data");
      }

    } catch (err) {
      console.error("Dashboard load error:", err);
      setError("Failed to load dashboard data.");
    } finally {
      setIsLoading(false);
    }
  };

  const check_if_installer = async (school_code: string, family_code: string, login: string): Promise<boolean> => {
    try {
      const response = await fetch(`${API_BASE_URL}api/check_installer_status/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          school_code,
          family_code,
          login
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.is_installer || false;
    } catch (error) {
      console.error('Error checking installer status:', error);
      return false;
    }
  };


  const handleJRChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setJrValue(e.target.value);
    if (e.target.value === "5" || e.target.value === "6") {
      setSrValue(""); // Hide senior roles for country manager/installer
    }
  };

  const handleSRChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSrValue(e.target.value);
  };

  const handleGetCategory = async () => {
    try {
      const login = sessionStorage.getItem("login");
      console.log("login", login)
      const school_code = sessionStorage.getItem("school_code");
      console.log("school code", school_code)
      const family_code = sessionStorage.getItem("family_code");
      console.log("family_code", family_code)
      const category = sessionStorage.getItem("category");
      console.log("category", category)
      const response = await fetch(`${API_BASE_URL}api/dealer_dashboard/category/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          school_code: school_code,
          family_code: family_code,
          login: login,
          jr_value: jrValue,
          sr_value: srValue,
          action: 'get_category' // Explicit action parameter
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.success) {
        setCategory(data.category);
        return true;
      } else {
        EL_Functions.ShowMessage(data.error || 'Failed to get category', 'E');
        return false;
      }
    } catch (error) {
      console.error('Error getting category:', error);
      EL_Functions.ShowMessage('Failed to get category', 'E');
      return false;
    }
  };

  const handleAddWorkForce = async (isAdd: boolean) => {
    if (!await handleGetCategory()) return;
    const action = isAdd ? 'A' : 'R';
    navigate(`/dealer/register_salesman?ARD=${action}&ARDCategory=${category}`);
  };

  const handleOfficeLogin = async () => {
    if (!selectedOffice) {
      EL_Functions.ShowMessage('Please select an office', 'A');
      return;
    }

    const office = offices.find(o => o.Login === selectedOffice);
    if (!office) return;

    try {
      const response = await fetch(`${API_BASE_URL}api/dealer_dashboard/login_as_office/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          office_login: office.Login,
          password: office.Password,
          action: 'login_as_office' // Explicit action parameter
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.success) {
        window.location.href = data.redirect_url;
      } else {
        EL_Functions.ShowMessage(data.error || 'Failed to login as office', 'E');
      }
    } catch (error) {
      console.error('Error logging in as office:', error);
      EL_Functions.ShowMessage('Failed to login as office', 'E');
    }
  };

  const fn_AddDNCNumbers = (e: React.MouseEvent) => {
    e.preventDefault();
    EL_Functions.Popup("../SUPPORT/EL_AddDNCNumbers_New.aspx?DNCAction=ADD", "", "width=600,height=300");
    return false;
  };

  const fn_UnDone = () => {
    EL_Functions.ShowMessage('Under Construction.', 'A');
    return false;
  };

  // const fn_OpenNewWindow = () => {
  //   window.open('../Sales/NewSales/EL_NewSale.aspx', 'open_window',
  //     'scrollbars, resizable, dependent, left=0, top=0, fullscreen=yes');
  //   return false;
  // };

  const fn_ShowSalesReport = (e: React.MouseEvent) => {
       e.preventDefault();
    const width = window.screen.availWidth - 10;
    const height = window.screen.availHeight - 80;
    EL_Functions.Popup("/WEBADMIN/REPORTS/KMDistributorSalesReport",
      "Show Sales Report", `width=${width},height=${height}`);
    return false;
  };

  const ShowPPTransaction = (e: React.MouseEvent) => {
    e.preventDefault();
    EL_Functions.Popup("../DEALER/EL_ListPaypalTransactions.aspx", "Paypal Transactions", "");
  };

  const ShowPPNotification = (e: React.MouseEvent) => {
    e.preventDefault();
    EL_Functions.Popup("../DEALER/EL_ListPaypalTransactions.aspx", "Paypal Transactions", "");
  };

  const EL_Functions = {
    ShowMessage: (message: string, type: string = 'A', title?: string, callback?: () => void): boolean => {
      if (type === 'Q') {
        const result = window.confirm(message);
        if (result && callback) callback();
        return result;
      } else {
        alert(message);
        if (callback) callback();
        return true;
      }
    },

    Popup: (url: string, title: string = '', options: string = '') => {
      const width = options.match(/w=(\d+)/)?.[1] || '800';
      const height = options.match(/h=(\d+)/)?.[1] || '600';
      const left = (window.screen.width - parseInt(width)) / 2;
      const top = (window.screen.height - parseInt(height)) / 2;

      window.open(url, title,
        `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`);
    },

    DisableContextMenu: () => {
      document.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        return false;
      });
    }
  };


  const renderDealerSection = () => {
    if (isLoading) {
      return <Loading />;
    }

    if (error) {
      return <div style={{ color: 'red', padding: '20px' }}>{error}</div>;
    }

    if (!roles || Object.keys(roles).length === 0) {
      return <div style={{ padding: '20px' }}>No roles assigned to this user.</div>;
    }

    return (
      <div id="divDealerAndDistributor" style={{
        marginLeft: '10px',
        marginRight: '40px',
        fontFamily: 'Arial',
        fontSize: '10pt',
        height: '466px',
        display: 'block',
        // borderRight: '2px solid #80A0FF',
      }}>
        <table style={{
          width: '100%',
          // border: '2px solid #80A0FF',
          //  borderRight: '1px solid #80A0FF',
          borderTop: 'none', paddingRight: "50px"
        }}>
          <tbody>
            {/* Register New Family */}
            {roles.RegisterNewFamily && (
              <tr style={{ display: 'table-row' }}>
                <td style={{ width: '100%', paddingBottom: '8px', height: '22px' }}>
                  <a href="/DEALER/EL_DealerRegisterFamily" style={{ color: 'blue' }}>Register New Family</a>
                </td>
              </tr>
            )}

            {/* List Families */}
            {roles.ListFamilies && (
              <tr style={{ display: 'table-row' }}>
                <td style={{ width: '100%', paddingBottom: '8px' }}>
                  <a href="/DEALER/EL_ListFamilies" style={{ color: 'blue' }}>List Families</a>
                </td>
              </tr>
            )}

            {/* List Subscriptions */}
            {roles.ListSubscriptions && (
              <tr style={{ display: 'table-row' }}>
                <td style={{ width: '100%', paddingBottom: '8px' }}>
                  <a href="/dealer/subscriptions" style={{ color: 'blue' }}>List Subscriptions</a>
                </td>
              </tr>
            )}

            {/* List of data captured from Payment Website */}
            {roles.ListOfDataCapturedFromPaymentWebsite && (
              <tr style={{ display: 'table-row' }}>
                <td style={{ width: '100%', paddingBottom: '8px', height: '22px' }}>
                  <a href="/dealer/payment_website_data" style={{ color: 'blue' }}>List of data captured from Payment Website</a>
                </td>
              </tr>
            )}

            {/* Paypal Transactions */}
            {roles.ListOfPaypalTransactions && (
              <tr style={{ display: 'table-row' }}>
                <td style={{ width: '100%', paddingBottom: '8px' }}>
                  <a href="#" onClick={ShowPPTransaction} style={{ color: 'blue' }}>List Paypal Transactions</a>
                </td>
              </tr>
            )}

            {/* Paypal Notifications */}
            {roles.ListOfPaypalNotifications && (
              <tr style={{ display: 'table-row' }}>
                <td style={{ width: '100%', paddingBottom: '8px' }}>
                  <a href="#" onClick={ShowPPNotification} style={{ color: 'blue' }}>List Paypal Notifications</a>
                </td>
              </tr>
            )}

            {/* Usage Analysis */}
            {roles.UsageAnalysis && (
              <tr style={{ display: 'table-row' }}>
                <td style={{ width: '100%', paddingBottom: '8px' }}>
                  <a href="/DEALER/EL_Dealer_UsageAnalysis" style={{ color: 'blue' }}>Usage Analysis</a>
                </td>
              </tr>
            )}

            {/* Add Work Force */}
            {roles.AddWorkForce && (
              <tr>
                <td style={{ paddingBottom: '8px', borderTop: 'solid 1px blue' }}>
                  <table style={{ width: '100%', fontWeight: 'bold', verticalAlign: 'top' }}>
                    <tbody>
                      <tr>
                        <td colSpan={3} align="center" style={{ backgroundColor: '#CCCCFF' }}>
                          Add Workforce
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={3} align="center" valign="top">
                          <select
                            id="ddlJr"
                            onChange={handleJRChange}
                            value={jrValue}
                            style={{ width: '110px', fontFamily: 'Arial', fontSize: '10pt' }}
                          >
                            <option value="1">Lead Collector</option>
                            <option value="2">Tele-Marketer</option>
                            <option value="3">Trainer</option>
                            <option value="4">Salesman</option>
                            <option value="5">B.D.M.</option>
                            <option value="6">Installer</option>
                          </select>

                          <select
                            id="ddlSr"
                            onChange={handleSRChange}
                            value={srValue}
                            style={{
                              width: '112px',
                              fontFamily: 'Arial',
                              fontSize: '10pt',
                              visibility: jrValue === "5" || jrValue === "6" ? 'hidden' : 'visible'
                            }}
                          >
                            <option value="2">City Manager</option>
                            <option value="3">Sales-Manager</option>
                            <option value="4">Team Leader</option>
                            <option value="5">Consultant</option>
                          </select>

                          &nbsp;
                          <button
                            onClick={() => handleAddWorkForce(true)}
                            style={{
                              width: '50px',
                              fontSize: '10pt',
                              fontWeight: 'bold',
                              cursor: 'pointer',
                              backgroundColor: '#119ECC',
                              color: "white",
                              border: "none",
                              padding: "2px"
                            }}
                          >
                            Add
                          </button>
                          &nbsp;
                          <button
                            onClick={() => handleAddWorkForce(false)}
                            style={{
                              width: '58px',
                              fontSize: '10pt',
                              fontWeight: 'bold',
                              cursor: 'pointer',
                              backgroundColor: '#119ECC',
                              color: "white",
                              border: "none",
                              padding: "2px"
                            }}
                          >
                            Modify
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            )}

            {/* Office Staff */}
            {roles.RegisterOffice && (
              <tr>
                <td style={{ width: '100%', paddingBottom: '8px', paddingLeft: '5px' }}>
                  <b>Office Staff:</b>&nbsp;&nbsp;&nbsp;
                  <a href="/dealer/register_office_accountant?ARD=A" style={{ color: 'blue' }}>Add</a>&nbsp;&nbsp;&nbsp;
                  <a href="/dealer/register_office_accountant?ARD=R" style={{ color: 'blue' }}>Modify</a>
                </td>
              </tr>
            )}

            {/* Office Login */}
            {roles.RegisterOffice && (
              <tr>
                <td style={{ paddingBottom: '8px' }}>
                  <b>Office:</b>&nbsp;&nbsp;&nbsp;
                  <a href="/dealer/register_office" style={{ color: 'blue' }}>Register</a>&nbsp;&nbsp;&nbsp;&nbsp;
                  <select
                    value={selectedOffice}
                    onChange={(e) => setSelectedOffice(e.target.value)}
                    style={{ width: '140px', fontFamily: 'Arial', fontSize: '10pt' }}
                  >
                    <option value="">-Select-</option>
                    {offices.map(office => (
                      <option key={office.Login} value={office.Login}>{office.FName}</option>
                    ))}
                  </select>
                  &nbsp;
                  <button
                    onClick={handleOfficeLogin}
                    style={{
                      width: '70px',
                      fontSize: '10pt',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      backgroundColor: '#119ECC',
                      color: "white",
                      border: "none",
                      padding: "2px"
                    }}
                  >
                    Login
                  </button>
                </td>
              </tr>
            )}

            {/* Country Manager */}
            {roles.CountryManager && (
              <tr style={{ display: 'table-row' }}>
                <td style={{ paddingBottom: '8px' }}>
                  <b>Country Manager:</b>&nbsp;&nbsp;
                  <a href="/dealer/register_salesman?ARD=A&ARDCategory=61" style={{ color: 'blue' }}>Register</a>&nbsp;&nbsp;&nbsp;
                  <a href="/dealer/list_salesman?ARDCategory=61" style={{ color: 'blue' }}>Modify</a>
                </td>
              </tr>
            )}

            {/* Search Engine */}
            {roles.SearchEngine && (
              <tr style={{ display: 'table-row' }}>
                <td style={{ paddingBottom: '8px' }}>
                  <a href="/support/search_engine" style={{ color: 'blue' }}>Search Engine</a>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  };

  const renderDistributorSection = () => {
    if (isLoading) {
      return <td style={{ width: '380px', paddingLeft: '5px' }}><Loading /></td>;
    }

    if (error) {
      return (<td style={{ color: 'red', textAlign: 'center', verticalAlign: 'middle' }} > {error} </td>);
    }

    if (!roles || Object.keys(roles).length === 0) {
      return <td style={{ width: '380px', paddingLeft: '5px' }}>No distributor options available</td>;
    }

    return (
      <td style={{ width: '380px', paddingLeft: '-100px', display: 'table-cell', verticalAlign: 'top' }}>
        <div style={{ overflowY: 'auto', overflowX: 'hidden', height: '420px', borderLeft: '1px solid #80A0FF', paddingLeft: '10px' }}>
          <table style={{ width: '100%', marginTop: '8px' }}>
            <tbody style={{ fontSize: "13px" }}>
              {/* New Sale */}
              {roles.NewSale && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ width: '100%', paddingBottom: '6px' }}>
                    {/* <a href="/SALES/NewSales/EL_CheckCMS" onClick={fn_OpenNewWindow} style={{ color: 'blue' }}>New Sale</a> */}
                    <a href="/SALES/NewSales/EL_CheckCMS" style={{ color: 'blue' }}>New Sale</a>
                  </td>
                </tr>
              )}

              {/* Sales */}
              {roles.ModifySale && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ width: '100%', paddingBottom: '8px' }}>
                    <a href="/SALES/SalesModify/EL_SalesModify" style={{ color: 'blue' }}>Sales</a>
                  </td>
                </tr>
              )}

              {/* View Customer Support */}
              {roles.ViewCustomerSupport && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ width: '100%', paddingBottom: '8px' }}>
                    <a href="/support/list_tasks?FilterType=CustView" style={{ color: 'blue' }}>View Customer Support</a>
                  </td>
                </tr>
              )}

              {/* Entry Customer Support */}
              {roles.EntryCustomerSupport && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ width: '100%', paddingBottom: '8px' }}>
                    <a href="/support/list_tasks?FilterType=CustEntry" style={{ color: 'blue' }}>Entry Customer Support</a>
                  </td>
                </tr>
              )}

              {/* Packages for Dispatch */}
              {roles.PackagesForDispatch && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ width: '100%', paddingBottom: '8px' }}>
                    <a href="/SALES/Dockets/EL_DeliveryDockets" style={{ color: 'blue' }}>Packages for Dispatch</a>
                  </td>
                </tr>
              )}

              {/* Pre-Audit Sales */}
              {roles.ApproveDeliveryDockets && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ width: '100%', paddingBottom: '8px' }}>
                    <a href="/DEALER/EL_ApproveDeliveryDockets" style={{ color: 'blue' }}>Pre-Audit Sales</a>
                  </td>
                </tr>
              )}

              {/* Payments Received */}
              {roles.PaymentsReceived && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ width: '100%', paddingBottom: '8px' }}>
                    <a href="/finance/payments/payment_received" style={{ color: 'blue' }}>Payments Received</a>
                  </td>
                </tr>
              )}

              {/* Crelogix */}
              {roles.Crelogix && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ width: '100%', paddingBottom: '8px' }}>
                    <a href="/finance/crelogix/main_menu" style={{ color: 'blue' }}>Crelogix</a>
                  </td>
                </tr>
              )}

              {/* Finance Sale */}
              {roles.FinanceSale && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ width: '100%', paddingBottom: '8px' }}>
                    <a href="/finance/families_to_finance" style={{ color: 'blue' }}>Finance Sale</a>
                  </td>
                </tr>
              )}

              {/* Invoice List */}
              {roles.InvoiceList && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ width: '100%', paddingBottom: '8px' }}>
                    <a href="/finance/invoice/customer_invoice_list" style={{ color: 'blue' }}>Invoice List</a>
                  </td>
                </tr>
              )}

              {/* Installation List */}
              {roles.InstallationList && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/sales/list_of_installations" style={{ color: 'blue' }}>Installation List</a>
                  </td>
                </tr>
              )}

              {/* Commission Payment Details */}
              {roles.CommissionPaymentDetails && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/finance/commissions/commission_payment_details" style={{ color: 'blue' }}>Commission Payment Details</a>
                  </td>
                </tr>
              )}

              {/* Order Dongle */}
              {roles.OrderPackages && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/sales/distributor/dongle_orders" style={{ color: 'blue' }}>OrderDongle</a>
                  </td>
                </tr>
              )}

              {/* Lead Collection */}
              {roles.LeadCollection && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/cms/leads" style={{ color: 'blue' }}>Lead Collection</a>
                  </td>
                </tr>
              )}

              {/* Telemarketing */}
              {roles.Telemarketing && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ paddingBottom: '8px' }}>
                    <table style={{ border: 'none' }}>
                      <tbody>
                        <tr>
                          <td>
                            <a href="/cms/call_monitor" style={{ color: 'blue' }}>Telemarketing</a>
                          </td>
                        </tr>
                        <tr>
                          <td style={{ paddingTop: '10px' }}>
                            <a href="/cms/list_confirm_lead" style={{ color: 'blue' }}>Prospective Client Appointments</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              )}

              {/* Distributor Orders */}
              {roles.DistributorOrders && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/sales/distributor/distributor_orders" style={{ color: 'blue' }}>Distributor Orders</a>
                  </td>
                </tr>
              )}

              {/* Modify Dongle Status */}
              {roles.ModifyDongleStatus && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/sales/distributor/update_status" style={{ color: 'blue' }}>Modify Dongle Status</a>
                  </td>
                </tr>
              )}

              {/* Dongle Workflow Report */}
              {roles.DongleWorkFlowReport && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/sales/distributor/dongle_workflow_summary" style={{ color: 'blue' }}>Dongle Workflow Report</a>
                  </td>
                </tr>
              )}

              {/* Sales Report */}
              {roles.SalesReport && (
                <tr style={{ display: 'table-row' }}>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="#" onClick={fn_ShowSalesReport} style={{ color: 'blue' }}>Sales Report</a>
                  </td>
                </tr>
              )}

              {/* DNC Search */}
              {roles.AddDNC && (
                <>
                  <tr style={{ display: 'table-row' }}>
                    <td style={{ paddingBottom: '8px' }}>
                      <a href="/support/add_dnc_numbers?DNC=Search" style={{ color: 'blue' }}>DNC Search</a>
                    </td>
                  </tr>
                  <tr style={{ display: 'table-row' }}>
                    <td style={{ paddingBottom: '8px' }}>
                      <a href="#" onClick={fn_AddDNCNumbers} style={{ color: 'blue' }}>Add DNC</a>
                    </td>
                  </tr>
                </>
              )}

              {/* MathsDoctor Features */}
              {roles.StrandSubstrandQns && (
                <tr>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/webadmin/mathsdoctor/manage_topics" style={{ color: 'blue' }}>Strand/Substrand/Qns</a>
                  </td>
                </tr>
              )}

              {roles.VoucherCodes && (
                <tr>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/WebAdmin/MATHSDOCTOR/MD_ManageVoucherCodes" style={{ color: 'blue' }}>Voucher Codes</a>
                  </td>
                </tr>
              )}

              {roles.MathsDoctor && (
                <tr>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/webadmin/mathsdoctor/link_md_mw" style={{ color: 'blue' }}>Maths Doctor- Maths Wiz Link</a>
                  </td>
                </tr>
              )}

              {roles.ViewQuestions && (
                <tr>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="#" onClick={(e) => {
                      e.preventDefault();
                      window.open('/sysadmin/mathsdoctor/mathsdoctor_questions', '_New');
                    }} style={{ color: 'blue' }}>View Questions</a>
                  </td>
                </tr>
              )}

              {roles.ViewExceptions && (
                <tr>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/WEBADMIN/MATHSDOCTOR/MD_ExceptionError" style={{ color: 'blue' }}>View Exceptions</a>
                  </td>
                </tr>
              )}

              {roles.PostQuestionCategory && (
                <tr>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/webadmin/mathsdoctor/validate_qn_types" style={{ color: 'blue' }}>Post Question Category</a>
                  </td>
                </tr>
              )}

              {roles.ViewLesson && (
                <tr>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/support/view_lesson" style={{ color: 'blue' }}>View Lesson</a>
                  </td>
                </tr>
              )}

              {roles.ViewGames && (
                <tr>
                  <td style={{ paddingBottom: '8px' }}>
                    <a href="/webadmin/games/manage_games" style={{ color: 'blue' }}>View Games</a>
                  </td>
                </tr>
              )}

              {/* Default WLP running out links */}
              <tr>
                <td style={{ paddingBottom: '8px' }}>
                  <a href="/support/list_wlps_runningout?Subject=Mathematics" style={{ color: 'blue' }}>Default WLP running out - Maths</a>
                </td>
              </tr>
              <tr>
                <td style={{ paddingBottom: '8px' }}>
                  <a href="/support/list_wlps_runningout?Subject=English" style={{ color: 'blue' }}>Default WLP running out - English</a>
                </td>
              </tr>
              <tr>
                <td style={{ paddingBottom: '8px' }}>
                  <a href="/support/list_wlps_runningout?Subject=Mathematics&Source=MD" style={{ color: 'blue' }}>MathsDoctor WLP running out</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </td>
    );
  };

  // =======================
  // MAIN RENDER
  // =======================

  const styles = {
    container: {
      width: '800px',
      height: '600px',
      backgroundImage: `url(${masterbg})`,
      backgroundSize: 'cover',
      fontFamily: 'Arial',
      margin: '0 auto',
      position: 'relative'
    } as React.CSSProperties,

    header: {
      height: '60px'
    } as React.CSSProperties,

    headerTable: {
      color: 'Maroon',
      fontWeight: 'bold',
      fontSize: '20px',
      fontFamily: 'calibri',
      padding: '5px',
      height: '25px',
      backgroundColor: '#C1E0FF',
      border: '2px solid #80A0FF',
      width: '100%'
    } as React.CSSProperties,

    headerCell: {
      width: '30%',
      textAlign: 'left' as const
    } as React.CSSProperties,

    headerText: {
      width: '95%',
      textAlign: 'center' as const
    } as React.CSSProperties,

    content: {
      display: 'flex',
      height: '540px',
      marginTop: '40px',
    } as React.CSSProperties,

    dealerSection: {
      marginLeft: '30px',
      // marginRight: '40px',
      fontFamily: 'Arial',
      fontSize: '10pt',
      width: '650px',
      height: '500px',
      // borderRight: '2px solid #80A0FF',
      borderTop: 'none',
      overflowY: 'auto'
    } as React.CSSProperties,

    distributorSection: {
      width: '380px',
      paddingLeft: '5px',
      verticalAlign: 'top' as const
    } as React.CSSProperties,

    link: {
      color: 'blue',
      textDecoration: 'underline',
      fontSize: '12pt',
      textAlign: 'right' as const,
      marginRight: '10px'
    } as React.CSSProperties,

    table: {
      width: '100%',
      marginTop: '8px'
    } as React.CSSProperties,

    tableCell: {
      width: '100%',
      paddingBottom: '8px'
    } as React.CSSProperties,

    addWorkForceTable: {
      width: '100%',
      fontWeight: 'bold' as const,
      // border: 'solid 1px blue',
      verticalAlign: 'top' as const
    } as React.CSSProperties,

    addWorkForceHeader: {
      backgroundColor: '#CCCCFF',
      textAlign: 'center' as const
    } as React.CSSProperties,

    select: {
      fontFamily: 'Arial',
      fontSize: '10pt',
      padding: '2px'
    } as React.CSSProperties,

    button: {
      fontSize: '10pt',
      fontWeight: 'bold' as const,
      marginLeft: '5px',
      cursor: 'pointer'
    } as React.CSSProperties,

    officeSection: {
      paddingBottom: '8px',
      paddingLeft: '5px'
    } as React.CSSProperties,

    errorMessage: {
      color: 'red',
      paddingLeft: '100px',
      textAlign: 'center' as const
    } as React.CSSProperties
  };

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <table style={styles.headerTable}>
          <tbody>
            <tr>

              <td style={styles.headerText}>
                Click on the following links to process:
              </td>
              <td style={styles.headerCell}>
                <a href=""
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/SysAdmin');
                  }}
                  style={styles.link}>Logout</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Main Content */}
      <div style={styles.content}>
        {isLoading ? (
          <div style={{ width: '100%', textAlign: 'center', padding: '20px' }}>
            <Loading />
          </div>
        ) : error ? (
          <div style={styles.errorMessage}>{error}</div>
        ) : (
          <>
            {/* Dealer Section */}
            <div style={styles.dealerSection}>
              {renderDealerSection()}
            </div>

            {/* Distributor Section */}
            {renderDistributorSection()}
          </>
        )}
      </div>
    </div>
  );
};

export default SupportDashboard;